import { useEffect } from 'react';
import { loadCountryFlagStyles } from '../phoneField.utils';

export const useCountryFlagStyles = () => {
  useEffect(() => {
    loadCountryFlagStyles();
  }, []);
};
